import { writable } from 'svelte/store';

const activityLog = writable([]);

export default activityLog;
